module.exports = __webpack_public_path__ + "static/media/user-plus.755ea4d4.svg";